export default __webpack_public_path__ + "static/media/com_lux.a92c6d43.png";